<template>
  <div id="app">
    <header class="app-header">
      <div class="header-content">
        <div class="header-text">
          <h1>{{ $t('app.title') }}</h1>
          <p>{{ $t('app.subtitle') }}</p>
        </div>
        <LanguageSwitcher />
      </div>
    </header>
    
    <main class="app-main">
      <router-view />
    </main>
    
    <footer class="app-footer">
      <p>{{ $t('app.footer') }}</p>
    </footer>
    
    <!-- 用户反馈组件 -->
    <UserFeedback />
  </div>
</template>

<script setup lang="ts">
import LanguageSwitcher from './components/LanguageSwitcher.vue'
import UserFeedback from './components/UserFeedback.vue'
</script>

<style scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem 1rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.header-content {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.header-text {
  text-align: center;
  flex: 1;
}

.header-content :deep(.language-switcher) {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.app-header h1 {
  margin: 0 0 0.5rem 0;
  font-size: 2.5rem;
  font-weight: 700;
}

.app-header p {
  margin: 0;
  font-size: 1.1rem;
  opacity: 0.9;
}

.app-main {
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.app-footer {
  background: #f8f9fa;
  text-align: center;
  padding: 1rem;
  color: #6c757d;
  border-top: 1px solid #e9ecef;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .app-header {
    padding: 1.5rem 1rem;
  }
  
  .app-header h1 {
    font-size: 2rem;
  }
  
  .app-header p {
    font-size: 1rem;
  }
  
  .header-content {
    flex-direction: column;
    gap: 1rem;
  }
  
  .header-text {
    text-align: center;
  }
  
  .header-content :deep(.language-switcher) {
    position: static;
    transform: none;
  }
}
</style>
